<template>
  <div class="edit-video-box">
    <el-dialog
        :title="'积分修改'"
        :visible.sync="dialogVisible"
        width="640px"
        :before-close="handleClose"
        :close-on-click-modal="false"
    >
      <el-form ref="form" :model="editParam" :rules="rules">
        <div class="flex just-center flex-c align-item-center">
          <div class="form_item flex-c align-item-center">
            <h1 class="mb-10">当前用户积分数量是：{{ currentPoints }}</h1>
            <el-form-item label="改为:" prop="points">
              <div style="display:flex; height: 42px; align-items: center;">
                <el-input-number
                    style="width: 280px"
                    v-model.number="editParam.points"
                    size="small"
                ></el-input-number>
              </div>
            </el-form-item>
          </div>
          <div class="dialog-footer">
            <el-button @click="handleClose" size="small">取 消</el-button>
            <el-button
                type="primary"
                @click="addUserGold"
                :loading="flag"
                size="small"
            >确 认
            </el-button
            >
          </div>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
import {validatorCutNumber} from "@/utils/validator";

export default {
  data() {
    return {
      uid: "",
      flag: false,
      dialogVisible:false,
      currentPoints: 0,
      editParam: {
        points: 0
      },
      rules: {
        points: [
          {required: true, message: "请输入积分", trigger: "blur"},
          {type: "number", message: "积分必须为数字"},
          {validator: validatorCutNumber, trigger: "blur"},
        ],
      },
    };
  },
  created() {
  },
  methods: {
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$refs["form"].resetFields();
    },
    // 加金币
    addUserGold() {
      let params = {
        uid: this.uid,
        points: this.editParam.points,
      };
      API.addUserPoints(params)
          .then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "操作成功！",
                type: "success",
              });
              this.$emit("goBack");
              this.handleClose();
            } else {
              this.$message.error("操作失败!");
            }
            // this.handleClose();
          })
          .catch(() => {
          });
    },
    open(row) {
      this.dialogVisible = true;
      this.uid = row.uid;
      this.editParam.points = row.points;
      this.currentPoints = row.points;
    },
  }
};
</script>

<style lang="scss">
.edit-video-box {
  .el-select,
  .el-textarea,
  .el-select > .el-input,
  .el-input {
    width: 100% !important;
  }
}

.form_item {
  display: flex;
}

.item .el-form-item__label {
  line-height: 20px !important;
}

/deep/ .el-form-item {
  margin-bottom: 10px !important;
}
</style>
